var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowL1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-QUINIELAS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-3",
    transform: "translate(-70.000000, -848.000000)",
    fill: "#E10600",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(85.500000, 863.500000) scale(-1, 1) translate(-85.500000, -863.500000) translate(70.000000, 848.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,0 C6.93958638,0 0,6.93958638 0,15.5 C0,24.0604136 6.93958638,31 15.5,31 C24.0604136,31 31,24.0604136 31,15.5 C31,6.93958638 24.0604136,0 15.5,0 Z M15.5,1 C23.5081289,1 30,7.49187113 30,15.5 C30,23.5081289 23.5081289,30 15.5,30 C7.49187113,30 1,23.5081289 1,15.5 C1,7.49187113 7.49187113,1 15.5,1 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,0 C6.93958638,0 0,6.93958638 0,15.5 C0,24.0604136 6.93958638,31 15.5,31 C24.0604136,31 31,24.0604136 31,15.5 C31,6.93958638 24.0604136,0 15.5,0 Z M15.5,1 C23.5081289,1 30,7.49187113 30,15.5 C30,23.5081289 23.5081289,30 15.5,30 C7.49187113,30 1,23.5081289 1,15.5 C1,7.49187113 7.49187113,1 15.5,1 Z",
    id: "Oval-Copy"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.071429, 8.928571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8571429,5.14285714 C14.4094276,5.14285714 14.8571429,5.59057239 14.8571429,6.14285714 C14.8571429,6.65569298 14.4711027,7.0783643 13.973764,7.13612941 L13.8571429,7.14285714 L1,7.14285714 C0.44771525,7.14285714 0,6.69514189 0,6.14285714 C0,5.6300213 0.38604019,5.20734998 0.883378875,5.14958487 L1,5.14285714 L13.8571429,5.14285714 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00717893,0.292893219 C8.36766289,-0.0675907428 8.93489395,-0.0953202783 9.32718516,0.209704612 L9.4213925,0.292893219 L14.5642496,5.43575036 C14.9247336,5.79623432 14.9524631,6.36346538 14.6474382,6.75575659 L14.5642496,6.84996392 L9.4213925,11.9928211 C9.0308682,12.3833454 8.39770322,12.3833454 8.00717893,11.9928211 C7.64669497,11.6323371 7.61896544,11.065106 7.92399033,10.6728148 L8.00717893,10.5786075 L12.443,6.142 L8.00717893,1.70710678 C7.64669497,1.34662282 7.61896544,0.779391764 7.92399033,0.387100557 L8.00717893,0.292893219 Z",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8571429,5.14285714 C14.4094276,5.14285714 14.8571429,5.59057239 14.8571429,6.14285714 C14.8571429,6.65569298 14.4711027,7.0783643 13.973764,7.13612941 L13.8571429,7.14285714 L1,7.14285714 C0.44771525,7.14285714 0,6.69514189 0,6.14285714 C0,5.6300213 0.38604019,5.20734998 0.883378875,5.14958487 L1,5.14285714 L13.8571429,5.14285714 Z",
    id: "Path-2-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00717893,0.292893219 C8.36766289,-0.0675907428 8.93489395,-0.0953202783 9.32718516,0.209704612 L9.4213925,0.292893219 L14.5642496,5.43575036 C14.9247336,5.79623432 14.9524631,6.36346538 14.6474382,6.75575659 L14.5642496,6.84996392 L9.4213925,11.9928211 C9.0308682,12.3833454 8.39770322,12.3833454 8.00717893,11.9928211 C7.64669497,11.6323371 7.61896544,11.065106 7.92399033,10.6728148 L8.00717893,10.5786075 L12.443,6.142 L8.00717893,1.70710678 C7.64669497,1.34662282 7.61896544,0.779391764 7.92399033,0.387100557 L8.00717893,0.292893219 Z",
    id: "Path-3-Copy"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowL1);
export default __webpack_public_path__ + "static/media/arrow-l-1.24490ef7ae6a5ad0d0922772d4c7cd07.svg";
export { ForwardRef as ReactComponent };